<template>
    <div style="padding: 30px;background-color: #e30000;">
        <div style="display: flex;">
            <div id="Yelement" style="position: relative;background-color: #000;"
                :style="'width:' + bg_width + 'px;height:' + bg_height + 'px'">
                <el-image src="https://video.kissxx.cn/src_img/tuwen_home.jpg"
                    :style="'width:' + bg_width + 'px;height:' + bg_height + 'px'" fit="cover">
                </el-image>
                <div style="position: absolute;top: 0;right: 0;left: 0;bottom: 0;padding: 30px;word-break: break-all;
                    color: #fff;background-color: #00000078;">
                    哈哈哈哈哈我的家乡111111111111111111111111111111111111111111111111<br /><br />哈哈哈哈哈我的家乡111111111111111111111111111111111111111111111111哈哈哈哈哈我的家乡111111111111111111111111111111111111111111111111哈哈哈哈哈我的家乡111111111111111111111111111111111111111111111111<br /><br />哈哈哈哈哈我的家乡111111111111111111111111111111111111111111111111哈哈哈哈哈我的家乡111111111111111111111111111111111111111111111111哈哈哈哈哈我的家乡111111111111111111111111111111111111111111111111
                </div>
            </div>
        </div>

        <button @click="saveImageCode">1</button>
    </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
import domToImage from 'dom-to-image';

export default {
    name: '',
    components: {

    },
    // 定义属性
    data() {
        return {
            bg_width: 330,
            bg_height: 450
        }
    },
    // 计算属性，会监听依赖属性值随之变化
    computed: {},
    // 监控data中的数据变化
    watch: {},
    // 方法集合
    methods: {
        // 保存二维码图片
        saveImageCode() {
            domToImage.toPng(document.getElementById('Yelement'),
                {
                    width: this.bg_width, // 高度宽度自行设定
                    height: this.bg_height,
                    scale: 2.5
                })
                .then(function (dataUrl) {
                    var img = new Image();
                    img.src = dataUrl;
                    console.log(img)
                    document.body.appendChild(img);
                })
                .catch(function (error) {
                    console.error('oops, something went wrong!', error);
                });

        },

    },
    // 生命周期 - 创建完成（可以访问当前this实例）
    created() {

    },
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {

    },
    beforeCreate() { }, // 生命周期 - 创建之前
    beforeMount() { }, // 生命周期 - 挂载之前
    beforeUpdate() { }, // 生命周期 - 更新之前
    updated() { }, // 生命周期 - 更新之后
    beforeDestroy() { }, // 生命周期 - 销毁之前
    destroyed() { }, // 生命周期 - 销毁完成
    activated() { }, // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style scoped>
.image-container {
    width: 400px;
    /* 调整为需要的宽度 */
    height: 300px;
    /* 调整为需要的高度 */
    background-image: cross-fade(url('http://video.kissxx.cn/src_img/tuwen_home.jpg?=1'), url('http://video.kissxx.cn/src_img/tuwen_home.jpg?=1'), 50%);
    /* 50% 表示两张图片各占一半的透明度 */
    background-size: cover;
    /* 调整背景图片大小以适应容器 */
}

.hebin {


    background-position: center;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    border-Radius: 10px;
    filter: blur(5px);
}

.hebin2 {

    background-position: center;
    background-repeat: no-repeat;
    background-size: 100% 100%;

}

.linearBg {
    background-image: linear-gradient(90deg, transparent, #ffffff00), url(http://video.kissxx.cn/src_img/tuwen_home.jpg?=1);
    width: 200px;
    height: 200px;
    background-size: 40%, contain;
    background-repeat: no-repeat;
    background-position: right;
}

.curtain:before {
    display: block;
    width: 100%;
    height: 32px;
    background: linear-gradient(var(--vp-c-bg), transparent 70%);
    content: "";
}
</style>


// WEBPACK FOOTER //
// src/components/User/Tp_tuiwen.vue


// WEBPACK FOOTER //
// src/components/User/Tp_tuiwen.vue